import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-health-details',
    templateUrl: './health-details.component.html',
    styleUrls: ['./health-details.component.scss'],
    standalone: false
})
export class HealthDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
